import React, { useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';


const FileUploadArea = ({ 
  onFileSelect, 
  acceptedFormats = ['.pdf', '.jpg', '.jpeg', '.png'],
  maxSizeMB = 5,
  multiple = true,
  label = 'Upload Documents'
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e?.preventDefault();
    setIsDragging(false);
  };

  const validateFiles = (files) => {
    const maxSize = maxSizeMB * 1024 * 1024; // Convert MB to bytes
    const invalidFiles = files.filter(file => file.size > maxSize);
    
    if (invalidFiles.length > 0) {
      alert(`The following files exceed ${maxSizeMB}MB limit:\n${invalidFiles.map(f => `${f.name} (${(f.size / 1024 / 1024).toFixed(1)}MB)`).join('\n')}`);
      return files.filter(file => file.size <= maxSize);
    }
    
    return files;
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragging(false);
    const files = Array.from(e?.dataTransfer?.files);
    const validFiles = validateFiles(files);
    if (validFiles.length > 0) {
      onFileSelect(validFiles);
    }
  };

  const handleFileInput = (e) => {
    const files = Array.from(e?.target?.files);
    const validFiles = validateFiles(files);
    if (validFiles.length > 0) {
      onFileSelect(validFiles);
    }
  };

  const handleClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      className={`
        border-2 border-dashed rounded-lg p-8 text-center cursor-pointer
        transition-smooth
        ${isDragging 
          ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 hover:bg-muted/50'
        }
      `}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple={multiple}
        accept={acceptedFormats?.join(',')}
        onChange={handleFileInput}
        className="hidden"
      />
      <div className="flex flex-col items-center gap-3">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Upload" size={32} color="var(--color-primary)" />
        </div>
        
        <div>
          <p className="text-base font-semibold text-foreground mb-1">
            {label}
          </p>
          <p className="text-sm text-muted-foreground">
            Drag and drop files here or click to browse
          </p>
        </div>
        
        <div className="flex flex-wrap items-center justify-center gap-2 mt-2">
          <span className="text-xs text-muted-foreground">
            Accepted formats: {acceptedFormats?.join(', ')}
          </span>
          <span className="text-xs text-muted-foreground">•</span>
          <span className="text-xs text-muted-foreground">
            Max size: {maxSizeMB}MB
          </span>
        </div>
      </div>
    </div>
  );
};

export default FileUploadArea;